import { RenderGroupRowProps } from "../../components/Table/types";
import IacManagementTableGroupRowCellName from "./CellName";
import IacManagementTableGroupRowCellResourcesCount from "./CellResourcesCount";
import IacManagementTableGroupRowCellDrifted from "./CellDrifted";
import IacManagementTableGroupRowCellSpace from "./CellSpace";
import IacManagementTableGroupRowCellVendor from "./CellVendor";
import IacManagementTableGroupRowCellUpdatedAt from "./CellUpdatedAt";
import IacManagementTableGroupRowCellActions from "./CellActions";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import IacManagementTableGroupRowCellResourceAddress from "./CellResourceAddress";
import IacManagementTableGroupRowCellResourceType from "./CellResourceType";
import { IacManagementGroupBy } from "../../types";

export type RenderGroupRowCellProps = {
  cellId: string;
  isFirst: boolean;
  isGroupOpen?: boolean;
} & Pick<RenderGroupRowProps, "row" | "stackViewMode" | "fetchDataLoading" | "loadResources">;

const CELL_PER_COLUMN = {
  [IAC_MANAGEMENTS_TABLE_COLUMNS.NAME]: IacManagementTableGroupRowCellName,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.RESOURCE_TYPE]: IacManagementTableGroupRowCellResourceType,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.RESOURCE_ADDRESS]: IacManagementTableGroupRowCellResourceAddress,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.RESOURCES]: IacManagementTableGroupRowCellResourcesCount,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.DRIFT_DETECTED]: IacManagementTableGroupRowCellDrifted,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.SPACE]: IacManagementTableGroupRowCellSpace,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.VENDOR]: IacManagementTableGroupRowCellVendor,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.UPDATED_AT]: IacManagementTableGroupRowCellUpdatedAt,
  [IAC_MANAGEMENTS_TABLE_COLUMNS.ACTIONS]: IacManagementTableGroupRowCellActions,
};

type IacManagementTableGroupRowProps = RenderGroupRowProps;

const IacManagementTableGroupRow = ({
  columns,
  row,
  stackViewMode,
  fetchDataLoading,
  groupMeta,
  loadResources,
  groupBy,
}: IacManagementTableGroupRowProps) => {
  const cellProps = {
    row,
    stackViewMode,
    fetchDataLoading,
    isGroupOpen: groupMeta?.isOpen,
    loadResources,
    groupBy,
  };

  if (groupBy === IacManagementGroupBy.None && stackViewMode) {
    return null;
  }

  return columns.map((column, i) => {
    const Cell = CELL_PER_COLUMN[column.id as IAC_MANAGEMENTS_TABLE_COLUMNS];
    const cellId = `${row.id}-${column.id}`;

    return <Cell key={cellId} cellId={cellId} isFirst={i === 0} {...cellProps} />;
  });
};

export default IacManagementTableGroupRow;
